import React, { FC, ReactNode } from 'react';
import { StyledFormPageTitle } from './FormPageTitle.styles';

export interface FormPageTitleProps {
  children: ReactNode;
}

const FormPageTitle: FC<FormPageTitleProps> = ({ children, ...props }) => (
  <StyledFormPageTitle {...props}>{children}</StyledFormPageTitle>
);
export default FormPageTitle;
